export default "__VITE_ASSET__CxzaL307__"